import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import PanelHeading from "../../components/panel/heading";
import UserPageWidget from "../../components/profile/pageWidget";
import PanelSubHeading from "../../components/panel/subHeading";
import UserProfileWatch from "../../components/profile/watchForm";
import DocumentWatchForm from "../../components/profile/documentWatchForm";
import { actions, RootState } from "../../state/reducer";
import { eventBackend, userBackend } from "../../services";
import {
  EventCardInfo,
  PaginatorCallback,
  UserPersonalData,
  UserPhoto,
} from "../../types";
import PreloaderPage from "../preloader";
import { toast } from "sonner";
import PanelPage from "../../components/panel/panelPage";
import { EventListRequestParams } from "../../forms/filters/event";
import EventListCard from "../../components/events/eventCard";
import Paginator from "../../components/paginator";
import { defPageSize } from "../../constants/events";
import NewPasswordModal from "../../modals/users/setPassword";
import { closeModal, openModal } from "../../state/modalSlice";

const WatchProfilePage = () => {
  const { id } = useParams();
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const userId = id && !isNaN(Number(id)) ? Number(id) : State.session?.id;
  const isMyPage = userId === Number(State.session?.id);
  const session = State.session;
  const [userData, setUserData] = useState<UserPersonalData | null>(null);
  const [userFiles, setUserFiles] = useState<UserPhoto[]>([]);
  const rights = State.rights;
  const [eventFilters, setEventFilters] = useState<EventListRequestParams>({
    user_id: userId,
    user_status_id: 2,
    status_ids: [3],
    offset: 0,
    limit: defPageSize
  });
  const [eventCards, setEventCards] = useState<EventCardInfo[]>([]);
  const [eventsCount, setEventsCount] = useState(0);

  useEffect(() => {
    if (!session) return;
    userBackend
      .getUserProfile(Number(userId))
      .then((res) => {
        if (!res?.data) {
          toast("Не удалось загрузить пользователя");
          return;
        }
        setUserData(res?.data);
      })
      .catch(() => {
        toast("Не удалось загрузить пользователя");
      });
    userBackend
      .getUserFiles(Number(userId))
      .then((res) => {
        setUserFiles(res.files || []);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [session]);

  useEffect(() => {
    if (userId) {
      eventBackend
        .getEventCards(userId, eventFilters)
        .then((res) => {
          setEventCards(res.events);
        })
        .catch((e) => {
          alert("Не удалось загрузить события");
          console.log("Error:", e);
        });
      eventBackend.getAllEventsCount(eventFilters).then((res) => {
        setEventsCount(res.count);
      });
    }
  }, [eventFilters])

  if (!userData) {
    return <PreloaderPage />;
  }

  if (!userId) {
    return (
      <PanelPage>
        <PanelHeading text={`Неизвестный пользователь`} />
      </PanelPage>
    );
  }

  const handleApplyPage: PaginatorCallback = (data) => {
    const filters: EventListRequestParams = {
      ...eventFilters,
      offset: data.page * data.perPage,
      limit: data.perPage,
    };
    setEventFilters(filters);
  };

  const handleOpenPasswordModal = () => {
    console.log("Called");
    dispatch(
      openModal({
        component: NewPasswordModal,
        context: {
          user_id: userId,
          onSave: (file: File) => {
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  return (
    <PanelPage>
      <div className="flex between">
        <PanelSubHeading
          text={`Профиль: ${userData?.last_name} ${userData?.first_name}`}
        />
        {rights.rang < 3 && <div className="panelBtnContainer">
          <div className="btn panelActionBtn" onClick={handleOpenPasswordModal}>
            Сменить пароль
          </div>
        </div>}
        <div className="panelBtnContainer">
          {isMyPage && (
            <a href="/profile/edit">
              <div className="btn panelActionBtn">Редактировать</div>
            </a>
          )}
        </div>
      </div>
      <div className="flex gap16 panelColumnFull">
        <div className="panelColumn2 columnLeft gap16">
          <UserPageWidget
            editable={false}
            profile={userData}
            files={userFiles}
          />
          <div className="profileWidget">
            <div className="panel panelInner">
              <UserProfileWatch data={userData} />
            </div>
          </div>
          {(rights.rang < 3 || userId === State.session?.id) && (
            <>
              <PanelSubHeading
                text={`Документы: ${userData?.last_name || ""} ${
                  userData?.first_name || ""
                }`}
              />
              <div className="profileWidget">
                <div className="panel panelInner">
                  <DocumentWatchForm userId={Number(userId)} />
                </div>
              </div>
            </>
          )}
        </div>
        <div className="panelColumn2 columnLeft gap16">
          <div className="panel eventListPanel">
            <div className="columnCenter">
              <div className="flex between w100">
                <PanelSubHeading text="Завершенные события" />
              </div>
              <div className="toDoHeadingBorder" />
              <div className="toDoHeading">Что сделано</div>
              {eventCards.map((event: EventCardInfo, index) => {
                return <EventListCard {...event} key={`hmpe${index}`} />;
              })}
              <div className="flex cardPaginator">
                {eventsCount > 5 && (
                  <Paginator
                    perPage={5}
                    count={eventsCount}
                    onDataChange={handleApplyPage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </PanelPage>
  );
};

export default WatchProfilePage;
